import type { UseFormReturn } from "react-hook-form";

import type { CareerIntentFormValues, CareerIntentStepId } from "./careerIntentForm";
import CareerGoalsQuestionField from "./_CareerGoalsQuestionField";
import CareerGoalsStepProgress from "./_CareerGoalsStepProgress";

export const CAREER_GOALS_FORM_ID = "career-goals-form";

export default function CareerGoalsForm({
  currentRole,
  disabled = false,
  errorMessage,
  form,
  showProgress,
  step,
  stepIndex,
  stepTitle,
  stepsLength
}: {
  currentRole?: string | null;
  disabled?: boolean;
  errorMessage?: string;
  form: UseFormReturn<CareerIntentFormValues>;
  showProgress: boolean;
  step: CareerIntentStepId;
  stepIndex: number;
  stepTitle: string;
  stepsLength: number;
}) {
  const values = form.watch();

  return (
    <form
      id={CAREER_GOALS_FORM_ID}
      className="flex flex-col gap-4 pt-12"
      data-testid="career-goals-form"
      onSubmit={(event) => event.preventDefault()}
    >
      {showProgress ? <CareerGoalsStepProgress stepIndex={stepIndex} stepsLength={stepsLength} /> : null}
      <div className="flex flex-col gap-3">
        <h2 className="text-headline-small font-serif text-sys-brand-on-surface">{stepTitle}</h2>
        <CareerGoalsQuestionField
          currentRole={currentRole}
          disabled={disabled}
          errorMessage={errorMessage}
          onChange={(nextValues) => {
            (Object.keys(nextValues) as (keyof CareerIntentFormValues)[]).forEach((key) => {
              form.setValue(key, nextValues[key], { shouldDirty: true });
            });
          }}
          step={step}
          values={values}
        />
      </div>
    </form>
  );
}
